import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'

import { InstitutionLogo } from '@mxenabled/mxui'

import { useAccountDisplayName } from '../../../common'
import { Account } from '../../../core'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface AccountActionProps {
  account: Account
}

export const AccountAction = ({ account }: AccountActionProps) => {
  const displayName = useAccountDisplayName(account)

  return (
    <ListItem sx={{ bgcolor: 'background.paper', p: 24 }}>
      <ListItemAvatar>
        <InstitutionLogo
          alt={account.name || ''}
          institutionGuid={account.institution_guid || ''}
        />
      </ListItemAvatar>
      <ListItemText
        primary={displayName}
        secondary={formatCurrency(account.balance || 0, '0,0.00')}
      />
    </ListItem>
  )
}
